import React from "react";
import { config } from "../../../../../../config";
import { Pill } from "../../../../../Atoms/Pill/Pill";

const TestPill = () => {
  return config.isProd ? null : (
    <Pill size="md" className="border-red-cardinal ml-2 border" theme="light">
      TEST
    </Pill>
  );
};

export default TestPill;
